module.exports = __webpack_public_path__ + "img/Icon2.48db9204.svg";